import { render, staticRenderFns } from "./WebServicesTable.vue?vue&type=template&id=9a5b509c&"
import script from "./WebServicesTable.vue?vue&type=script&lang=js&"
export * from "./WebServicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports